import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import videoPlayer from "../video/videoComponent";
import Plyr from "plyr";
import CONSTANT from "../../common/js/_constant";

gsap.registerPlugin(ScrollTrigger);

const whyChooseChli = {
    variables: {
        whyChooseChliWrapper: "whychoosechli__wrapper",
        textElement: "animation-text",
        animationContainer: "whyChooseCHLI__animation_container",
        overlayContainer: "overlay_container",
        imgVideoWrapper: "whyChooseCHLI__animation_container__img_video",
        videoElement: "whyChooseCHLI__animation--video-desktop",
    },
    methods: {
        animateText: function () {
            let mm = gsap.matchMedia();
            mm.add("(min-width: 768px)", () => {
                $(`.${whyChooseChli.variables.textElement}`).each((index, element) => {
                    whyChooseChli.methods.animateTitle(element);
                });
                $(`.${whyChooseChli.variables.animationContainer}`).each((index, element) => {
                    whyChooseChli.methods.animateOverlayAndVideo(element);
                });
            });
        },
        animateTitle: function (element) {
            gsap.to(element, {
                scrollTrigger: {
                    trigger: element,
                    start: "top bottom",
                    end: "bottom center",
                    scrub: true,
                },
                scale: 5,
                transformOrigin: "center center",
            });
        },
        animateOverlayAndVideo: function (element) {
            if ($(element).find(`.${whyChooseChli.variables.videoElement}`).length) {
                const video = new Plyr(`.${whyChooseChli.variables.videoElement}`, {
                    ...CONSTANT.videoOption
                });
                // Same play-button label fix as the other videos (WCAG 2.5.3)
                videoPlayer.methods.removeDuplicatePlayText(video);
                video.autoplay = true;
                video.muted = true;
                video.loop = true;
                video.volume = 0;
                video.play();
            }

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top top",
                    end: "+=1500",
                    // scrub:1 debounces the scrub over 1s instead of syncing
                    // instantly on every scroll event — reduces micro-jitter
                    // that disrupts text selection.
                    scrub: 1,
                    pin: element,
                    // pinType:"transform" uses CSS transform for pinning
                    // instead of position:fixed. This plays much better
                    // with browser text selection during drag-to-select
                    // (Release 2 Item #1 / DG-13).
                    pinType: "transform",
                    anticipatePin: 1,
                },
            });

            timeline.to(
                `.${whyChooseChli.variables.animationContainer} .${whyChooseChli.variables.textElement}`,
                {
                    scale: 400,
                    transformOrigin: "center center",
                    duration: 1,
                }
            );
            timeline.to(
                `.${whyChooseChli.variables.animationContainer} .${whyChooseChli.variables.textElement}`,
                {
                    y: -1000,
                    x: -1000,
                },
                0.1
            );
            timeline.to(
                `.${whyChooseChli.variables.animationContainer} .${whyChooseChli.variables.overlayContainer}`,
                {
                    opacity: 0,
                    duration: 1,
                },
                0.1
            );
            timeline.to(
                `.${whyChooseChli.variables.animationContainer} .${whyChooseChli.variables.overlayContainer}`,
                {
                    display: "none",
                },
                0.1
            );
            timeline.to(
                `.${whyChooseChli.variables.animationContainer} .${whyChooseChli.variables.imgVideoWrapper}`,
                {
                    mask: "none",
                    duration: 1,
                }
            );
        },
        whyChooseChliVideo: function () {
            videoPlayer.methods.registerVideo(".whyChooseCHLI__animation--video-mobile");
        },
        // The brand-film <video> tags are rendered with preload="none" so the
        // ~7 MB file isn't buffered at page load (the page carries three copies,
        // two of them hidden at any viewport). Once a copy is about to scroll
        // into view, switch it to preload="metadata" so Plyr still shows the
        // real duration before the user presses play, exactly as before.
        // Hidden copies never intersect, so they never download. play() (the
        // desktop background video) loads the file on its own.
        loadMetadataNearViewport: function () {
            const videos = document.querySelectorAll(
                ".whyChooseCHLI__animation--video-mobile, .whyChooseCHLI__animation--video-desktop"
            );
            if (!videos.length) return;
            const loadMetadata = (video) => {
                if (video.preload === "none") {
                    video.preload = "metadata";
                }
            };
            if (!("IntersectionObserver" in window)) {
                videos.forEach(loadMetadata);
                return;
            }
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        loadMetadata(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, { rootMargin: "100% 0px" });
            videos.forEach((video) => observer.observe(video));
        },
        // True when rendered inside the AEM page editor's content frame.
        // Content embedded via an Experience Fragment is rendered with
        // wcmmode=disabled, so the HTL `!wcmmode.edit` guard doesn't apply.
        // AEM Cloud opens the editor inside the Unified Shell
        // (/ui#/aem/editor.html/...): editor.html is in the top window's hash,
        // not its path, and the shell sandboxes the editor frame, so reading
        // window.top.location can throw. Check the content frame's own signals
        // first, and treat an unreadable top window as the editor (the live
        // site's CSP only allows our own domains to frame it).
        isAuthorEditor: function () {
            if (window.self === window.top) {
                return false;
            }
            const editorPath = /\/editor\.html\//;
            if (editorPath.test(document.referrer)) {
                return true;
            }
            const classes = `${document.documentElement.className} ${document.body ? document.body.className : ""}`;
            if (/(^|\s)aem-AuthorLayer-/.test(classes)) {
                return true;
            }
            try {
                const topLocation = window.top.location;
                return editorPath.test(topLocation.pathname) || editorPath.test(topLocation.hash);
            } catch (e) {
                return true;
            }
        },
        init: function () {
            if (whyChooseChli.methods.isAuthorEditor()) {
                // The editor iframe auto-resizes to its content height, so 100vh
                // sections + the ScrollTrigger pin spacer grow the iframe in an
                // endless loop. Skip the pin animation and neutralise vh heights.
                $(`.${whyChooseChli.variables.whyChooseChliWrapper}`).addClass(
                    `${whyChooseChli.variables.whyChooseChliWrapper}--author`
                );
            } else {
                whyChooseChli.methods.animateText();
            }
            whyChooseChli.methods.whyChooseChliVideo();
            whyChooseChli.methods.loadMetadataNearViewport();
        },
    },
};

$(() => {
    if ($(`.${whyChooseChli.variables.whyChooseChliWrapper}`).length) {
        whyChooseChli.methods.init();
    }
});
